import styled from '@emotion/styled';
import { Dot } from './Dot';

type Props = {
  color: string;
  text: string;
};

export const LegendEntry = ({ color, text, ...props }: Props) => {
  return (
    <S.Wrapper {...props}>
      <Dot color={color} size="8px" />
      {text}
    </S.Wrapper>
  );
};

const S = {
  Wrapper: styled.span`
    display: flex;
    align-items: center;
    gap: 4px;
  `,
};
